import { columns } from './incidentAnalysisColumn'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'

function formatDate(dateString) {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })
}

const IncidentAnalysisTable = ({ isLoading, data, displayDate }) => {
    return (
        <>
            <div className="mb-4">
                <h1 className="mb-4">Incident Analysis</h1>

                <div
                    style={{
                        backgroundColor: 'var(--azureLight)',
                        color: 'var(--mainText)',
                    }}
                    className="d-flex align-items-center justify-content-center py-2 px-lg-4 px-3 rounded-lg my-3"
                >
                    <h6 className=" fw-normal py-2">
                        {formatDate(displayDate?.startDate)} and{' '}
                        {formatDate(displayDate?.endDate)}
                    </h6>
                </div>

                <ReactDataTable
                    isLoading={isLoading}
                    data={data}
                    columns={columns}
                    removePagination={true}
                />
            </div>
        </>
    )
}

export default IncidentAnalysisTable
